import React, { useContext } from 'react';
import InterviewPracticeQuestionDndItem from './questionDndItem';
import { DroppableProvided, DroppableStateSnapshot } from 'react-beautiful-dnd';
import { useInterview } from '@components/pass/interview/start/context/interviewContext';

interface Props {
  provided: DroppableProvided;
  snapshot: DroppableStateSnapshot;
}

const InterviewPracticeQuestionDndList: React.FC<Props> = ({ provided }) => {
  const { selectedQuestionList } = useInterview();

  const renderQuestionEls = () => {
    return selectedQuestionList.map((it, index) => {
      return <InterviewPracticeQuestionDndItem key={it.sn} index={index} data={it} />;
    });
  };

  return (
    <ul {...provided.droppableProps} ref={provided.innerRef}>
      {renderQuestionEls()}
      {provided.placeholder}
    </ul>
  );
};

export default InterviewPracticeQuestionDndList;
